export default __webpack_public_path__ + "static/media/ES.eddf8ed1.svg";